export default __webpack_public_path__ + "static/media/blog-post-3.8ffcdfbb.jpg";